import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { obtenerDatos, datosSedes } from "../../firebase/firebase-methods";
import "./BuscadorMedicamentos.css";
import { ModalFichaMedicamento } from "../buscador/modal/ModalFichaMedicamento";
import { ModalPopUpCompraMedicamento } from "./modal/ModalPopUpCompraMedicamento";
import { ModalStockMedicamento } from "./modal/ModalStockMedicamento";
import { ModalPopUpSolicitud } from "./modal/ModalPopUpSolicitud";
import { ModalPopUp } from "./modal/ModalPopUp";
import { setSedes } from "../../slices/sedesSlice";
import {
  setMedicamentos,
  setMedicamentosFiltrados,
} from "../../slices/medicamentosSlice";
import { useDispatch, useSelector } from "react-redux";
import { ModalLoading } from "./modal/ModalLoading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faPhoneFlip,
  faCartShopping,
  faCircleInfo,
  faBoxesStacked,
  faCircleExclamation,
  faHandHoldingMedical,
  faBasketShopping,
  faPlane,
  faFileSignature,
  faClipboardQuestion,
} from "@fortawesome/free-solid-svg-icons";
import { useMediaQuery } from "react-responsive";

export default function BuscadorMedicamentos() {
  const isMdAndUp = useMediaQuery({ query: "(min-width: 768px)" });
  const dispatch = useDispatch();
  const [busqueda, setBusqueda] = useState("");
  const [medicamento, setMedicamento] = useState({});
  const [showModalFichaMedicamento, setShowModalFichaMedicamento] =
    useState(false);
  const [showModalPopUpCompraMedicamento, setShowModalPopUpCompraMedicamento] =
    useState(false);
  const [showStockMedicamento, setShowStockMedicamento] = useState(false);
  const [showModalPopUpSolicitud, setShowModalPopUpSolicitud] = useState(false);
  const [showModalPopUp, setShowModalPopUp] = useState(false);
  const [showModalLoading, setShowModalLoading] = useState(true);
  const { medicamentos, medicamentosFiltrados } = useSelector(
    (state) => state.medicamentos,
  );

  const filtrarElementos = () => {
    if (busqueda.length >= 3) {
      const values = busqueda.split(" ");
      let arregloPActivo = [];
      let concentracion = "";

      values.forEach((element) => {
        if (!isNaN(element)) {
          concentracion = element.trim();
        } else {
          const pActivo = medicamentos.filter(
            (m) =>
              (m.principio_activo ?? "")
                .toLowerCase()
                .includes(element.toLowerCase()) ||
              (m.nombre_medicamento ?? "")
                .toLowerCase()
                .includes(element.toLowerCase()),
          );

          if (pActivo.length > 0) {
            arregloPActivo = pActivo;
          }
        }
      });

      const arregloFinal = arregloPActivo.filter((m) =>
        m.concentracion.toLowerCase().includes(concentracion.toLowerCase()),
      );
      // console.log("arreglo")
      // console.log(arregloFinal)

      dispatch(setMedicamentosFiltrados(arregloFinal));
    } else {
      dispatch(setMedicamentosFiltrados([]));
    }
  };

  const handleInputChange = (e) => {
    const nuevaBusqueda = e.target.value;
    setBusqueda(nuevaBusqueda);
  };

  const handleFichaMedicamento = (medicamento) => {
    // console.log(medicamento);
    setMedicamento(medicamento);
    setShowModalFichaMedicamento(true);
  };

  const cerrarModal = () => {
    setShowModalFichaMedicamento(false);
    setMedicamento({});
  };

  const irVonline = (medicamento) => {
    setMedicamento(medicamento);
    setShowModalPopUpCompraMedicamento(true);
  };

  const solicitar = (medicamento) => {
    setMedicamento(medicamento);
    setShowModalPopUpSolicitud(true);
  };
  const consultaStock = (medicamento) => {
    setShowModalLoading(true);
    // desactivar loading cuando se obtenga la data
    setMedicamento(medicamento);
    setShowStockMedicamento(true);
    setShowModalLoading(false);
  };

  const Llamar = () => {
    window.location.href = "tel:6003001515";
  };

  const abrirPopUp = () => {
    setShowModalPopUp(true);
  };

  const windowWidth = window.innerWidth;

  //useEffect que se ejecuta al cargar la pagina
  //llamada a la funcion obtenerDatos
  const LlamarContac = () => {
    window.location.href = "tel:6003001515";
  };
  useEffect(() => {
    const obtenerProductos = async () => {
      try {
        const arrProductos = await obtenerDatos();
        // console.log("Productos obtenidos:", arrProductos);
        const arrSedes = await datosSedes();
        dispatch(setMedicamentos(arrProductos));
        //  dispatch(setMedicamentosImportados(arrProductos));
        dispatch(setSedes(arrSedes));
        setShowModalLoading(false);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };
    obtenerProductos();
  }, []);
  //useEffect que se ejecuta al cambiar el valor de busqueda
  //llamada a la funcion filtrarElementos
  useEffect(() => {
    filtrarElementos();
  }, [busqueda]);

  if (showModalLoading) {
    return (
      <div className="App-header">
        <ModalLoading showModalLoading={showModalLoading} />
      </div>
    );
  } else {
    return (
      <div className="px-2 App-header">
        <div className="row pt-5">
          <div className="col-md-12">
            <h4 className="pb-3 titulo-busqueda">
              Ingrese principio activo o nombre de medicamento
            </h4>
            <p className="d-none">ver: 09/03/2026</p>
          </div>
          <div className="col-md-12">
            <input
              value={busqueda}
              onChange={handleInputChange}
              className={isMdAndUp ? "busqueda-distinta" : "input-busqueda"}
              type="text"
              placeholder=" Buscar por medicamento o principio activo"
            />
          </div>
        </div>
        {medicamentosFiltrados.length === 0 && busqueda.length < 3 ? (
          <div className="row pt-3 d-flex justify-content-between">
            <div className="alerta-buscador" role="alert">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 pt-3">
                <button className="boton llamar-sinMed" onClick={LlamarContac}>
                  <FontAwesomeIcon icon={faPhone} className="pe-2" />
                  6003001515
                </button>
              </div>
              <div className="row pt-3">
                <p>Servicio de importación de medicamentos: </p>
              </div>
              <div className="row ">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <button
                    className="boton sinmed"
                    onClick={() => solicitar("")}
                  >
                    MÁS INFORMACIÓN
                    <FontAwesomeIcon icon={faFileSignature} className="icono" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : medicamentosFiltrados.length === 0 && busqueda.length >= 3 ? (
          <div className="row pt-3">
            <div className="alerta-buscador" role="alert">
              <FontAwesomeIcon icon={faCircleExclamation} className="pe-3" />
              Medicamento o principio activo o concentración no encontrada.
            </div>
          </div>
        ) : (
          <div className="row pt-5 max-width">
            {medicamentosFiltrados.map((medicamento, index) => (
              <div
                className={
                  windowWidth >= 960 && windowWidth < 1520
                    ? "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-4"
                    : windowWidth >= 1520
                      ? "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3"
                      : "col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3"
                }
                key={index}
              >
                <div
                  className="card mb-3 "
                  style={{ maxWidth: "100%", maxHeight: "100%" }}
                >
                  <div className="row g-0">
                    <div className="col-md-9 col-9 col-sm-9 col-lg-9 col-xl-9 col-xxl-9">
                      <div className="card-body pb-0">
                        <h6 className="card-text">
                          <small
                            className="text-body-secondary"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "inline-block",
                              maxWidth: "200px",
                            }}
                          >
                            {medicamento.principio_activo}
                          </small>
                        </h6>
                        <OverlayTrigger
                          placement="right-end"
                          overlay={
                            <Tooltip bsPrefix="tlt-inner" id="tooltip-id">
                              {medicamento.nombre_medicamento}{" "}
                            </Tooltip>
                          }
                        >
                          <h5
                            data-toggle="tooltip"
                            data-placement="top"
                            className="card-title"
                            style={{
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color: "#3e6090",
                            }}
                          >
                            {medicamento.nombre_medicamento}
                          </h5>
                        </OverlayTrigger>
                        <h6 className="card-text">
                          <small className="text-body-secondary">
                            {medicamento.contenido}
                          </small>
                        </h6>
                        <h6 className="cond_venta card-text">
                          {/* {medicamento.cond_venta ===
                          "Receta Medica Retenida sin Control de Stock" ? (
                            <p>Venta bajo Receta Retenida</p>
                          ) : null}
                          {medicamento.cond_venta ===
                            "Receta Medica Retenida con Control de Stock" &&
                          medicamento.tipo_controlado === "PSI" ? (
                            <p>Venta bajo Receta Cheque</p>
                          ) : null}
                          {medicamento.cond_venta ===
                            "Receta Medica Retenida con Control de Stock" &&
                          medicamento.tipo_controlado !== "PSI" ? (
                            <p>Venta bajo Receta Retenida</p>
                          ) : null}
                          {medicamento.cond_venta === "Receta Medica" ? (
                            <p>Venta requiere Receta Médica</p>
                          ) : null}
                          {medicamento.cond_venta === "Directa" ? (
                            <p>Venta Directa</p>
                          ) : null} */}
                          {medicamento.tipo_venta ===
                          "Receta Medica Retenida" ? (
                            <p>Venta bajo Receta Retenida</p>
                          ) : null}
                          {medicamento.tipo_venta === "Receta Cheque" ? (
                            <p>Venta bajo Receta Cheque</p>
                          ) : null}

                          {medicamento.tipo_venta === "Receta Medica" ? (
                            <p>Venta requiere Receta Médica</p>
                          ) : null}
                          {medicamento.tipo_venta === "Directa" ? (
                            <p>Venta Directa</p>
                          ) : null}
                        </h6>
                        {medicamento.comercio_elec === false ||
                        medicamento.tipo_venta === "Receta Cheque" ? (
                          <h6
                            className="card-text"
                            style={{ color: "#3e6090", fontSize: "0.9rem" }}
                          >
                            <strong>
                              SOLO VENTA PRESENCIAL
                              <FontAwesomeIcon
                                icon={faHandHoldingMedical}
                                className="ps-2"
                              />
                            </strong>
                          </h6>
                        ) : medicamento.nombre_medicamento.includes(
                            "SYNACTHEN DEPOT",
                          ) ? (
                          <h6
                            className="card-text"
                            style={{ color: "#008f39", fontSize: "0.9rem" }}
                          >
                            <strong>
                              COMPRA POR IMPORTACIÓN
                              <FontAwesomeIcon
                                icon={faPlane}
                                className="ps-2"
                              />
                            </strong>
                          </h6>
                        ) : (
                          <h6
                            className="card-text"
                            style={{ color: "#3e6090", fontSize: "0.9rem" }}
                          >
                            <strong>
                              VENTA PRESENCIAL Y ONLINE
                              <FontAwesomeIcon
                                icon={faBasketShopping}
                                className="ps-2"
                              />
                            </strong>
                          </h6>
                        )}
                      </div>
                    </div>
                    <div className="col-md-3 col-3 col-sm-3 col-lg-3 col-xl-3 col-xxl-3 mt-1 pe-1">
                      <img
                        src={medicamento.image.length > 0 ? medicamento.image[0].url : null}
                        className="img-fluid rounded  float-start"
                        alt="..."
                        style={{ maxHeight: "100%" }}
                      ></img>
                      {medicamento.precio !== medicamento.precio_con_dscto ? (
                        <p className="precio-anterior original mb-0">{`$${medicamento.precio.toLocaleString("es-CL")}`}</p>
                      ) : null}
                      <p className="precio mb-0">{`$${medicamento.precio_con_dscto.toLocaleString(
                        "es-CL",
                      )}`}</p>
                    </div>
                   
                  </div>
                  <div className="row pt-2">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 pb-3">
                      {medicamento.nombre_medicamento.includes(
                        "SYNACTHEN DEPOT",
                      ) ? null : (
                        <button
                          onClick={() => consultaStock(medicamento)}
                          type="button"
                          className="boton stock"
                        >
                          STOCK SEDES
                          <FontAwesomeIcon
                            icon={faBoxesStacked}
                            className="icono"
                          />
                        </button>
                      )}
                      <button
                        onClick={() => handleFichaMedicamento(medicamento)}
                        type="button"
                        className="boton detalle"
                      >
                        DESCRIPCIÓN
                        <FontAwesomeIcon
                          icon={faCircleInfo}
                          className="icono"
                        />
                      </button>
                      {medicamento.nombre_medicamento.includes(
                        "SYNACTHEN DEPOT",
                      ) ? (
                        <button
                          onClick={abrirPopUp}
                          type="button"
                          className="boton contacto"
                        >
                          CONSULTAR DISPONIBILIDAD
                          <FontAwesomeIcon
                            icon={faClipboardQuestion}
                            className="icono"
                          />
                        </button>
                      ) : medicamento.comercio_elec === false ||
                        medicamento.tipo_venta === "Receta Cheque" ? (
                        <button className="boton comprar" onClick={Llamar}>
                          6003001515
                          <FontAwesomeIcon
                            icon={faPhoneFlip}
                            className="icono"
                          />
                        </button>
                      ) : (
                        <button
                          disabled={ medicamento.image.length > 0 ?
                            medicamento.image[0].url ===
                            "/static/media/sin_foto.5f9ed34dcfa0bb8ca88c.png" : null
                          }
                          onClick={() => irVonline(medicamento)}
                          type="button"
                          className="boton comprar"
                        >
                          COMPRAR
                          <FontAwesomeIcon
                            icon={faCartShopping}
                            className="icono"
                          />
                        </button>
                      )}
                      {/* {
  medicamento.nombre_medicamento.includes('IMPORT') || medicamento.nombre_medicamento.includes('(IMP)') ?
  <button className='boton llamar-med' onClick={Llamar}>
  6003001515  
  <FontAwesomeIcon icon={faPhoneFlip} className='icono'/>
  </button>
  :
  null
} */}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {showStockMedicamento && !showModalLoading ? (
              <ModalStockMedicamento
                showStockMedicamento={showStockMedicamento}
                handleCloseStockMedicamento={() =>
                  setShowStockMedicamento(!showStockMedicamento)
                }
                medicamento={medicamento}
              />
            ) : null}
            {showModalFichaMedicamento ? (
              <ModalFichaMedicamento
                showModalFichaMedicamento={showModalFichaMedicamento}
                handleCloseModalFichaMedicamento={cerrarModal}
                medicamento={medicamento}
              />
            ) : null}
            {showModalPopUpCompraMedicamento ? (
              <ModalPopUpCompraMedicamento
                showModalPopUpCompraMedicamento={
                  showModalPopUpCompraMedicamento
                }
                handleCloseModalPopUpCompraMedicamento={() =>
                  setShowModalPopUpCompraMedicamento(
                    !showModalPopUpCompraMedicamento,
                  )
                }
                medicamento={medicamento}
              />
            ) : null}
            {showModalLoading ? (
              <ModalLoading showModalLoading={showModalLoading} />
            ) : null}
          </div>
        )}
        {showModalPopUpSolicitud ? (
          <ModalPopUpSolicitud
            showModalPopUpSolicitud={showModalPopUpSolicitud}
            handleCloseModalPopUpSolicitud={() =>
              setShowModalPopUpSolicitud(!showModalPopUpSolicitud)
            }
            medicamento={medicamento}
          />
        ) : null}
        {showModalPopUp ? (
          <ModalPopUp
            showModalPopUp={showModalPopUp}
            handleCloseModalPopUp={() => setShowModalPopUp(!showModalPopUp)}
          />
        ) : null}
      </div>
    );
  }
}
